/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notify_Shopping_SubInputs */

const en_notify_shopping_sub = /** @type {(inputs: Notify_Shopping_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`On the shopping day, with the list`)
};

const de_notify_shopping_sub = /** @type {(inputs: Notify_Shopping_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Am Einkaufstag, mit der Liste`)
};

/**
* | output |
* | --- |
* | "On the shopping day, with the list" |
*
* @param {Notify_Shopping_SubInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const notify_shopping_sub = /** @type {((inputs?: Notify_Shopping_SubInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notify_Shopping_SubInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_notify_shopping_sub(inputs)
	return en_notify_shopping_sub(inputs)
});